import Foldouts from './Foldouts';
const els = document.querySelectorAll('.foldout');

if (els.length > 0) {
    Foldouts(els);
}
